var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClocktimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 60.269 30.771 L 47.201 41.304 c -0.624 -0.367 -1.341 -0.593 -2.116 -0.593 c -2.318 0 -4.204 1.886 -4.204 4.204 c 0 1.794 1.135 3.318 2.721 3.921 v 23.038 c 0 0.819 0.664 1.484 1.484 1.484 s 1.483 -0.664 1.483 -1.484 V 48.836 c 1.585 -0.602 2.721 -2.126 2.721 -3.921 c 0 -0.457 -0.092 -0.889 -0.227 -1.301 l 13.07 -10.534 c 0.637 -0.514 0.738 -1.448 0.224 -2.086 C 61.84 30.357 60.907 30.256 60.269 30.771 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45.084 -0.085 c -24.813 0 -45 20.187 -45 45 c 0 24.814 20.187 45.001 45 45.001 c 24.813 0 45 -20.187 45 -45.001 C 90.084 20.102 69.897 -0.085 45.084 -0.085 z M 45.084 86.949 c -23.177 0 -42.033 -18.856 -42.033 -42.034 c 0 -23.177 18.856 -42.033 42.033 -42.033 c 23.177 0 42.033 18.856 42.033 42.033 C 87.117 68.093 68.261 86.949 45.084 86.949 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClocktimer);
export default __webpack_public_path__ + "static/media/clocktimer.71a4308537058582857f77a6d92902bb.svg";
export { ForwardRef as ReactComponent };